import { useCallback, useState } from 'react';

import { readSpecialCharHistory, recordSpecialCharUsed } from '../storage/specialChars';

// Same shape as useState([]), but backed by localStorage (see storage/specialChars.js)
// so a user's recently-used ALT codes survive a refresh.
export default function useSpecialCharHistory() {
  const [history, setHistory] = useState(() => readSpecialCharHistory());

  const recordUsed = useCallback((entry) => {
    setHistory(recordSpecialCharUsed(entry));
  }, []);

  return { history, recordUsed };
}
